import cn from 'classnames';
import { ReactNode, useState } from 'react';

type Tab = {
  label: ReactNode;
  content: ReactNode;
};

type TabProps = {
  tabs: Tab[];
  className?: string;
  actions?: ReactNode;
  onChange?: (tabIndex: number) => void;
};

export function Tabs({ tabs, className, actions, onChange }: TabProps) {
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleChange = (index: number) => {
    setActiveTab(index);
    onChange?.(index);
  };

  return (
    <div className={cn('w-full flex flex-col rounded-lg bg-[#18181B]', className)}>
      <div className="relative flex items-center pb-1 after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-px after:h-px after:bg-zinc-800">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={cn(
              'text-sm text-zinc-400 px-4 py-3 font-medium relative border-b-2 border-transparent transition-all duration-200',
              'hover:text-zinc-200',
              {
                'text-white border-white': activeTab === index,
              },
            )}
            onClick={() => handleChange(index)}
          >
            {tab.label}
          </button>
        ))}
        {actions ? <div className="ml-auto flex items-center">{actions}</div> : null}
      </div>
      <div className="mt-4">{tabs[activeTab].content}</div>
    </div>
  );
}
